import { VeltComments, VeltSidebarButton, VeltCommentsSidebar } from '@veltdev/react';
import { useEffect } from 'react';
import './CommentsSidebar.css';

function CommentPage() {

    useEffect(() => {
        document.querySelector('velt-comments')?.setAttribute('dark', '');
    }, []);

    return (
        <>
            <VeltComments />
            <VeltCommentsSidebar />
            <div className="comment-tool-container">
                <p className='boujeeText'>Click the Comments Sidebar button in the bottom right.</p>
                <VeltSidebarButton />
            </div>
        </>
    )
}

export default CommentPage;